import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createAuthorisedPickup, createCurriculum, createEmergencyContact, createMeal, deleteCurriculum, fetchAuthorisedPickup, fetchCurriculumCategory, fetchCurriculumPlan, fetchEmergencyContact, removeAuthorisedPickup, removeEmergencyContact, updateAuthorisedPickup, updateCurriculum, updateEmergencyContact, updateStatusCurriculum } from "../../../service/api";


export const getAuthorisedPickup = createAsyncThunk(
    "authorised/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAuthorisedPickup(params)
            console.log("authorised contact", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const addAuthorisedPickup = createAsyncThunk(
    "authorised/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createAuthorisedPickup(formValue)
            if (response.status === 201) {
                console.log("authorised", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editAuthorisedPickup = createAsyncThunk(
    "authorised/edit",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateAuthorisedPickup(formValue)
            if (response.status === 201) {
                console.log("edit authorised", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const deleteAuthorisedPickup = createAsyncThunk(
    "authorised/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await removeAuthorisedPickup(formValue)
            if (response.status === 201) {
                console.log("delete authorised pickup", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


const authorisedSlice = createSlice({
    name: "authorisedPickup",
    initialState: {
        authorisedList: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        searchParams: "",

    },
    reducers: {

        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },

    },

    extraReducers: (builder) => {
        builder
            //GET
            .addCase(getAuthorisedPickup.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getAuthorisedPickup.fulfilled, (state, action) => {
                state.isLoading = false;
                state.authorisedList = action.payload.data;

            })

            .addCase(getAuthorisedPickup.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


            // POST
            .addCase(addAuthorisedPickup.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addAuthorisedPickup.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addAuthorisedPickup.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // PUT
            .addCase(editAuthorisedPickup.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editAuthorisedPickup.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editAuthorisedPickup.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // delete
            .addCase(deleteAuthorisedPickup.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteAuthorisedPickup.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteAuthorisedPickup.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})

export const { setSearchParams } = authorisedSlice.actions;

export default authorisedSlice.reducer;
